export class DisconnectRestoreAccountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DisconnectRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
